import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";

export default function BlogPost() {
    const { slug } = useParams();
    const [post, setPost] = useState(null);
    const [err, setErr] = useState("");

    useEffect(() => {
        api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setErr("Post not found"));
    }, [slug]);

    if (err) {
        return (
            <div className="min-h-[60vh] flex flex-col items-center justify-center">
                <p>{err}</p>
                <Link to="/blog" className="mt-4 text-gold-500">← Back to Journal</Link>
            </div>
        );
    }
    if (!post) return <div className="min-h-[60vh] flex items-center justify-center text-gold-500">Loading…</div>;

    return (
        <div data-testid="blog-post-page">
            <section className="mx-auto max-w-3xl px-6 pt-20 pb-6">
                <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-gold-500">
                    <ArrowLeft size={16} /> All articles
                </Link>
            </section>
            {post.cover && (
                <div className="mx-auto max-w-5xl px-6">
                    <img src={post.cover} alt={post.title} className="w-full h-[360px] object-cover rounded-2xl border border-white/10" />
                </div>
            )}
            <article className="mx-auto max-w-3xl px-6 py-14">
                <div className="flex gap-2 mb-4 flex-wrap">
                    {(post.tags || []).map((t) => (
                        <span key={t} className="text-[10px] tracking-[0.2em] uppercase text-gold-500 border border-gold-500/40 rounded-full px-2 py-0.5">{t}</span>
                    ))}
                </div>
                <h1 className="font-display text-4xl md:text-5xl font-black leading-tight tracking-tight">{post.title}</h1>
                <div className="mt-4 text-sm text-white/50">By {post.author}</div>
                <div className="mt-10 prose prose-invert max-w-none text-white/80 leading-relaxed whitespace-pre-wrap font-sans text-lg">
                    {post.body}
                </div>
            </article>
        </div>
    );
}
